import { render, staticRenderFns } from "./QuoteFormAdditional.vue?vue&type=template&id=bfae6c44&scoped=true&"
import script from "./QuoteFormAdditional.vue?vue&type=script&lang=ts&"
export * from "./QuoteFormAdditional.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteFormAdditional.vue?vue&type=style&index=0&id=bfae6c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfae6c44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
